import React from 'react';

const SVG = ({ style = {}, color = 'rgb(255, 255, 255)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <path d="M 17,50 L 42,28 55,28 38,44 81,44 81,55 38,55 55,72 42,72" fill={color} />
    </g>
  </svg>
);

export default SVG;
